import { $, doAction } from '@situation/setdesign.util';

class NavItem {
    constructor($item, index) {
        this.$el = $item;
        this.index = index;
        this.$headline = $item.find('.home-slider__nav-item-headline');
        this.$link = $item.find('.home-slider__nav-item-link');

        if (this.$link.length) {
            this.$link.attr('aria-hidden', 'true');
        }

        this.$el.attr({ role: 'button', 'aria-current': 'false' });
        this.$headline.html(
            this.$headline
                .html()
                .replace(/(^|<\/?[^>]+>|\s+)([^\s<]+)/g, '$1<span class="headline-word">$2</span>'),
        );

        this.$words = this.$headline.find('.headline-word');
        this.handleClick = this.handleClick.bind(this);
        this.$el.on('click', this.handleClick);
    }

    clamp() {
        this.$words.removeClass('hide').find('.ellipsis').remove();
        const rows = SetDesign.groupByRow(this.$words);
        if (rows.length > 2) {
            let count = 0;
            $.each(rows, (index, $row) => {
                if (count > 1) {
                    $row.addClass('hide');
                }

                count += 1;
            });

            rows[1].last().append($('<span class="ellipsis">&hellip;</span>'));
        }
    }

    resize(height) {
        this.$el.height(height);
    }

    handleClick() {
        doAction('home-carousel/goto', this.index);
    }

    select(selectedIndex, topItem) {
        const isActive = this.index === selectedIndex;
        this.$el.toggleClass('home-slider__nav-item--active', isActive);
        let tabIndex = this.index - topItem < 3 && this.index - topItem >= 0 ? '0' : '-1';
        if (isActive) {
            tabIndex = -1;
        }

        this.$el.attr('tabindex', tabIndex);
        this.$el.attr('role', isActive ? 'none' : 'button');
        this.$el.attr('aria-current', isActive ? 'true' : 'false');

        if (this.$link.length) {
            this.$link.attr('aria-hidden', isActive ? 'false' : 'true');
        }
    }
}

export default NavItem;
